import { post, get } from '@/utils/request'

/**
 * @description   获取用户管理列表
 * @param {*} params
 */
export async function getList (params) {
  const res = await get('/api/hrm/list', params)
  if (res.code === 'success') {
    res.data.list = res.data.list.map(
      ({ password, sex, loginTime, isValid, openid, mpopenid, ...rest }) => ({
        ...rest,
        sex,
        isValid,
        openid,
        mpopenid,
        sexName: sex === '1' ? '男' : '女',
        isValidName: isValid === '1' ? '可用' : '不可用',
        openidName: openid ? '已绑定' : '未绑定',
        mpopenName: !mpopenid ? '已注销' : '未注销',
      })
    )
  }
  return res
}

/**
 * @description   解除微信绑定
 * @param {*} params
 */
export async function userUntying (params) {
  return get('/api/json/user/removeOpenid', params)
}
/**
 * @description   锁定账户
 * @param {*} params
 */
export async function userFrozen (params) {
  return get('/api/json/user/lockuser', params)
}
/**
 * @description   重置密码
 * @param {*} params
 */
export async function userReset (params) {
  return get('/api/json/user/ResetPassWord', params)
}
/**
 * @description   新增修改用户管理数据
 * @param {*} params
 */
export async function saveUser (params) {
  return post('/api/json/user/addAndUpdate', params)
}
/**
 * @description   注销小程序账号
 * @param {*} params
 */
export async function miniCancellation (params) {
  return get('/api/json/user/removeMpOpenid', params)
}
/**
 * @description   获取用户权限列表
 * @param {*} params
 */
export async function getUpdpmi (params) {
  return get('/api/hrm/getpmi', params)
}

/**
 * @description   设置用户权限列表
 * @param {*} params
 */
export async function setUpdpmi (params) {
  return post('/api/hrm/updpmi', params)
}

/**
 * @description:           异步校验工号
 * @param {Object}  parms  工号
 * @return:                res
 */
export async function checkEmployeeId (params) {
  return get('/api/hrm/check', params)
}
/**
 * @description   删除账号
 * @param {*} params
 */
export async function deleteUser (id) {
  return get(`/api/json/user/deleteMember/${id}`)
}
